import { useMutation } from '@tanstack/react-query'
import { withdrawFromPortfolio } from 'services/RewardsService'

export const useWithdrawFromPortfolioMutation = () =>
  useMutation({
    mutationFn: withdrawFromPortfolio,
  })
